export function toFixedDown(numberValue: string, digits: number) {
    if(!numberValue || digits==null) return numberValue;
    numberValue = numberValue.toString();
    let re;
    if (digits === 0) {
        re = new RegExp("(-?\\d+)(\\.\\d*)?");
    } else {
        re = new RegExp("(-?\\d+\\.\\d{" + digits + "})(\\d)");
    }

    const m = numberValue.match(re);
    return m ? m[1] : numberValue;
};
